// Copyright (c) 2016 Deere & Company

const dealerDisplayFormats = ['01', '02', '03', '04', '05', '06', '07', '08', '09'];

export const buildDealerString = (dealerFormat, dealer) => {

    const stateSeperator = (dealer.location.state === '') ? '' : ', ';

    const displayFormats = {
        '01': `${dealer.account} - ${dealer.location.city}${stateSeperator}${dealer.location.state} (${dealer.industryIndicator})`,
        '02': `${dealer.account} - ${dealer.location.city}${stateSeperator}${dealer.location.state} ${dealer.location.country} (${dealer.industryIndicator})`,
        '03': `${dealer.account} - ${dealer.location.city}${stateSeperator}${dealer.location.state}`,
        '04': `${dealer.account}`,
        '05': `${dealer.location.city}${stateSeperator}${dealer.location.state} ${dealer.location.country} (${dealer.industryIndicator}) ${dealer.account}`,
        '06': `${dealer.location.city}${stateSeperator}${dealer.location.state} - ${dealer.account}`,
        '07': `${dealer.name} - ${dealer.account} - ${dealer.location.city}${stateSeperator}${dealer.location.state}`,
        '08': `${dealer.name}, ${dealer.location.city}${stateSeperator}${dealer.location.state} - ${dealer.account}`,
        '09': `${dealer.name} - ${dealer.account}`
    };

    return dealerDisplayFormats.includes(dealerFormat) ? displayFormats[dealerFormat] : displayFormats['08'];

};



// WEBPACK FOOTER //
// ./src/shared/services/build-dealer-string.js